module.exports = __webpack_public_path__ + "img/party-2018-museum.aa7fda89.jpg";